import type {FontMetadata} from '@contentlab/api/fonts/types';
import contentStudioInstance from '@/utils/axiosContentStudio';

const getAllFonts = async (): Promise<FontMetadata[]> => {
  const response = await contentStudioInstance.get('/api/v1/captions/fonts');
  return response.data;
};

const getFontById = async (fontId: string): Promise<FontMetadata> => {
  const response = await contentStudioInstance.get(
    `/api/v1/captions/fonts/${fontId}`
  );
  return response.data;
};

const fontFetchers = {
  getAllFonts,
  getFontById,
};

export default fontFetchers;
